<template>
  <div>
    <div class="summary-customer">
      <CustomerFormModal
        :current-customer.sync="changeCustomer"
        :invalid.sync="invalidPersonal"
        :show.sync="showCustomerDataFormModal"
        :loading.sync="loading"
        :show-toast="false"
        @after-success="afterSuccessPersonalData"
        @cancel="cancelPersonalDataModal"
      >
        <template v-for="slot in possibleChildSlotsFor('CustomerFormModal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </CustomerFormModal>
      <h2 class="h3">
        <slot name="headline"></slot>
      </h2>
      <ul class="list-unstyled">
        <div class="customer-data">
          <li>
            <div class="row">
              <div class="label">
                <slot name="lblFirstName"></slot>
              </div>
              <div>{{ currentCustomer.firstName }} {{ currentCustomer.lastName }}</div>
            </div>
          </li>
          <li>
            <div class="row" v-if="simType === 'SIM_CARD'">
              <div class="label">
                <slot name="lblAddress"></slot>
              </div>
              <div>
                {{ currentCustomer.address.street }} {{ currentCustomer.address.houseNumber }}
                <br>
                {{ currentCustomer.address.zip }} {{ currentCustomer.address.city }}
                <span v-if="currentCustomer.address.supplement !== ''">
              <br>{{ currentCustomer.address.supplement }}
          </span>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="label">
                <slot name="lblBirthdate"></slot>
              </div>
              <div>{{ currentCustomer.birthDate }}</div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="label">
                <slot name="lblEmail"></slot>
              </div>
              <div>{{ currentCustomer.email }}</div>
            </div>
          </li>
          <li>
            <div class="row" v-if="currentCustomer.alternativePhone">
              <div class="label">
                <slot name="lblPhone"></slot>
              </div>
              <div>{{ currentCustomer.alternativePhone }}</div>
            </div>
          </li>
          <li>
            <div class="row" v-if="simType === 'E_SIM'">
              <div>
                <slot name="eSimInfoText"></slot>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <button v-if="process === 'belatedPorting'" type="button" :aria-label="getSlotText('ariaLabelEditButtonMnp')" @click="editCustomer" class="edit-icon icon-only">
      <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
    </button>
  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import CustomerFormModal from '@/components/checkout/belatedPorting/summary/CustomerFormModal.vue'
import { splitError } from '@/helper/splitError'
import cloneDeep from 'lodash.clonedeep'

export default {
  import: {
    cloneDeep
  },
  name: 'Customer',
  components: { CustomerFormModal },
  data () {
    return {
      showCustomerDataFormModal: false,
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        email: '',
        address: {
          street: '',
          houseNumber: '',
          zip: '',
          city: '',
          supplement: ''
        },
        alternativePhone: ''
      },
      changeCustomer: {
        address: {
          street: '',
          houseNumber: '',
          zip: '',
          city: '',
          supplement: ''
        },
        email: '',
        alternativePhone: ''
      },
      invalidPersonal: false,
      loading: true
    }
  },
  props: {
    process: {
      type: String,
      default: 'belatedPorting'
    },
    simType: {
      type: String,
      default: 'SIM_CARD'
    }
  },
  methods: {
    editCustomer () {
      this.showCustomerDataFormModal = true
      this.changeCustomer = cloneDeep(this.currentCustomer)
      const data = {
        information_action: 'submit',
        information_name: 'personal data bnp',
        information_ui_type: 'layover',
        information_trigger: 'icon'
      }

      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    afterSuccessPersonalData () {
      const _this = this
      _this.$apollo.queries.currentCustomer.refetch()
      _this.$store.dispatch('checkoutv2/' + this.process + '/initiate')
        .then(() => {
          this.loading = false
          this.clearToasts()
          this.$emit('goForward')
        }).catch((error) => {
          _this.loading = false
          _this.errorToast(this.getErrorMessage(error))
          _this.triggerErrorTracking(error)
        })
    },
    cancelPersonalDataModal () {
      this.changeCustomer = cloneDeep(this.currentCustomer)
      this.showCustomerDataFormModal = false
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            salutation,
            firstName,
            lastName,
            birthDate,
            email,
            address {
              street,
              houseNumber,
              zip,
              city,
              supplement
            },
            alternativePhone
          }
        }`, this, 'currentCustomer', {}, () => {
          this.loading = false
        },
        { fetchPolicy: 'no-cache' },
        (error) => {
          splitError(error).forEach(e => { this.errorMsg = e.message })
          this.errorToast(this.errorMsg)
          this.loading = false
        }
      )
    }
  }
}
</script>
